import styled from '@emotion/styled';

export const StyledHeading = styled.div`
  width: 100%;
  padding: 10px 20px;
`;
